import { render } from "./CaseDetailPage.vue?vue&type=template&id=b2f7787c"
import script from "./CaseDetailPage.vue?vue&type=script&lang=js"
export * from "./CaseDetailPage.vue?vue&type=script&lang=js"

import "./CaseDetailPage.vue?vue&type=style&index=0&id=b2f7787c&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__